import { render } from "./SwipeArrows.vue?vue&type=template&id=6ceb3616&scoped=true&ts=true"
import script from "./SwipeArrows.vue?vue&type=script&lang=ts"
export * from "./SwipeArrows.vue?vue&type=script&lang=ts"

import "./SwipeArrows.vue?vue&type=style&index=0&id=6ceb3616&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceb3616"]])

export default __exports__